import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import { withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import Header from '../Inc/Layout/Header.js';
import Footer from '../Inc/Layout/Footer.js';
import { getAllBlogsAction } from '../../actions/home';
import ReactHtmlParser from 'react-html-parser';
import './blog.css';
class BlogSingle extends Component {
   constructor(props){
      super(props);      
      this.state = {
          header: "",   
          items:[],    
          viewBlog:{},          
          viewLoadCount:0,                 
      }; 
      this.loadMore = this.loadMore.bind(this);    
      this.readMore = this.readMore.bind(this);    
    }

    componentWillMount() {
        this.props.getAllBlogsAction()
    }
    componentWillReceiveProps(nextProps) {
        if(nextProps.blogData && nextProps.blogData.length > 0){
            let viewBlog = {};
            let { params } = this.props.match;
            for (let i in nextProps.blogData){
                    if(nextProps.blogData[i].title.replaceAll(' ', '-') === params.title ){
                        viewBlog = nextProps.blogData[i];
                        break;
                    }
                    else if(nextProps.blogData[i].title.replaceAll(' ', '-') === params.title + this.props.location.search ){
                        viewBlog = nextProps.blogData[i];
                        break;
                    }
                    else if(nextProps.blogData[i].title.replaceAll(' ', '-') === params.title+'?' ){
                        viewBlog = nextProps.blogData[i];
                        break;
                    }
            }
            this.setState({
                items:nextProps.blogData,
                viewLoadCount:nextProps.blogData.length,
                viewBlog:viewBlog
            })
        }
    }

     readMore (data,index){
        setTimeout(() => {
            this.setState({
                viewBlog:data
            })
          }, 1);       
        this.props.history.push({
            pathname:"/blog-view/"+data.title.replaceAll(' ', '-'),
            state:{"BlogDetails":data},
        });
     }
     sortText(text){
        let textA = ReactHtmlParser(text);
         textA = textA.substr(0, 150)
        return textA
      }
     loadMore() {
        const {viewLoadCount} = this.state;
        this.setState({
            viewLoadCount :viewLoadCount+4
        })
     }
render() {
    const {items, viewBlog , viewLoadCount} = this.state;
return (
<div className="outer-wrapper">
    <Header />
    <div>
        <div className="container">
            <div className="row">
                <div className="col-md-8">
                    <h1 className="main-heading mt-5">Blog</h1>
                    <div className="page-content">
                        <div className="single_blog_page">
                            <div className="single_blog_wrap">
                                <div className="single_blog_img">
                                    <img src={process.env.REACT_APP_SERVER_IMAGE_BUCKET +"/"+viewBlog.image} alt="blogImage"/>
                                </div>
                                <h3>{viewBlog.title}</h3>
                                <div className="single_blog_content">{ReactHtmlParser(viewBlog.description)}</div>
                                <div className="blog_footer"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-4">
                    <h1 className="main-heading mt-5">Other Blog</h1>
                <div className="sideScroll">
                    {items.slice(0, viewLoadCount).map((item, index) => {
                        if(viewBlog._id!=item._id) return (
                            <div className="" key={index}>
                                <div className="blog_wrap">
                                    {/* <div className="date_wrap">
                                       <span className="blog_date">20</span>
                                        <span className="blog_Month">Aug</span>
                                    </div> */}
                                    {/* <div className="Blog_img_leftSide"><img src={process.env.REACT_APP_SERVER_IMAGE_BUCKET +"/"+item.image} className="Blog_img_leftSide" alt="blogImage"/></div> */}
                                    <div className="Blog_meta_leftSide">
                                        <div  className="Blog_ttl_leftSide">{item.title}</div>
                                        {/* <div className="Blog_short_des_leftSide">{ReactHtmlParser(item.description)}</div> */}
                                        <div className="blog_read_more_leftSide" onClick={()=>this.readMore(item,index)}>
                                            <button className="btn">Read More</button>
                                        </div>
                                    </div>
                                    <div className="blog_footer_leftSide"></div>
                                </div>
                            </div> 
                        );
                    })}
                  </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</div>
)
}
}

function mapStateToProps(state) {
    //console.log("state.home",state.home)
  return {
    blogData : state.home.blogResponse
  }
}


export default withLocalize(withRouter(connect(mapStateToProps, {

    getAllBlogsAction
})(BlogSingle)));


// WEBPACK FOOTER //
// ./src/components/Blog/Blogsingle.js